import { observer } from 'mobx-react-lite'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { CompleteOnboardingCard } from '@/features/jobs/details/components/CompleteOnboardingCard'
import { links } from '@/utils/link'

export interface CompleteOnboardingCardContainerProps {
  vm: JobDetailsViewModel
}

export const CompleteOnboardingCardContainer = observer(
  function CompleteOnboardingCardContainer({
    vm,
  }: CompleteOnboardingCardContainerProps) {
    return (
      <CompleteOnboardingCard
        questionsCompleted={vm.questionsCompleted}
        canManageBilling={vm.billingVm.canManageBilling}
        checkoutUrl={links.checkout(vm.job.id)}
        onSubmit={vm.actionsVm.submitJobDialogVm.show}
        onEditResponses={vm.actionsVm.editDraft}
      />
    )
  },
)
